import { SettingsBootstrap } from '@/features/settings/SettingsBootstrap';
import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router';

import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { AuthProvider } from '@/features/auth/context/AuthProvider';

import { QueryProvider } from './QueryProvider';

/**
 * Point unique d'assemblage des contextes globaux.
 *
 * L'ordre compte : `ErrorBoundary` enveloppe tout pour rattraper aussi les
 * erreurs levées à l'initialisation des providers. Les futurs contextes
 * (authentification, thème, i18n) viennent s'ajouter ici, jamais dans `main.tsx`.
 */
export const AppProviders = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary>
    <QueryProvider>
      {/* `AuthProvider` est sous `QueryProvider` : la déconnexion purge le
          cache de requêtes, il lui faut donc le client. Il reste au-dessus du
          routeur, pour que les gardes de route lisent l'état d'authentification. */}
      <AuthProvider>
        <SettingsBootstrap>
          <BrowserRouter>{children}</BrowserRouter>
        </SettingsBootstrap>
      </AuthProvider>
    </QueryProvider>
  </ErrorBoundary>
);
